/** Dev-only language that renders translation keys instead of texts. */
export const SHOW_TRANSLATION_KEY = 'show-translation-key';

export const SUPPORTED_LANGUAGE_TYPES = [
  'de-DE',
  'en-GB',
  'fr-FR',
  'pl-PL',
  SHOW_TRANSLATION_KEY,
] as const;
export type LangType = (typeof SUPPORTED_LANGUAGE_TYPES)[number];
export const DEFAULT_LANGUAGE_TYPE: LangType = 'en-GB';
